import { all } from "redux-saga/effects";

import allSessionsSagas from "./allSessions";

export default function* sessionsSagas() {
  yield all([allSessionsSagas()]);
}
